import { render, staticRenderFns } from "./BoxHeading.vue?vue&type=template&id=00659456&lang=pug&"
import script from "./BoxHeading.vue?vue&type=script&lang=ts&"
export * from "./BoxHeading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports